import Config from 'react-native-config';

export enum DUE_STATUS_TYPE {
  DELINQUENT = 'Overdue',
  DUE_NOW = 'Due Now',
  PAST_DUE = 'Past Due',
  UNKNOWN = ''
}
export type DueStatusKey = keyof typeof DUE_STATUS_TYPE;

export enum VisitPayImhSource {
  mhios = 'mhios',
  mhand = 'mhand',
  mhweb = 'mhweb'
}

export type VisitPayImhSourceKey = keyof typeof VisitPayImhSource;

export const ENTRI_PAY_HOME_URL = `${Config.VISIT_PAY_URL}&redirectUrl=/Home`;
export const LEGACY_BILLPAY_URL = 'https://www.intermountainbillpay.com/#/Guest';
export const GUARANTOR_VERIFICATION_PHONE_NUMBER = '1-866-415-6556';
export const COLLECTIONS_NUMBER_CBE = '855-459-1109';
export const COLLECTIONS_NUMBER_IC = '888-229-8870';
